import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { providerFeature, ProviderFeature } from '@fmnts/common';
import { OnlyRequireProps } from '@fmnts/core';
import {
  FMNTS_RAISENOW_TAMARO_HOST_OPTIONS,
  TamaroHostOptions,
} from './raisenow-integration.tokens';

enum RaiseNowUiFeatureKind {
  Tamaro,
}

/**
 * A feature for use when configuring `provideRaiseNowUi`.
 */
type RaiseNowUiFeature<TKind extends RaiseNowUiFeatureKind> =
  ProviderFeature<TKind>;

const { make: makeRaisenowUiFeature } =
  providerFeature<RaiseNowUiFeatureKind>();

export function provideRaiseNowUi(
  ...features: RaiseNowUiFeature<RaiseNowUiFeatureKind>[]
): EnvironmentProviders {
  return makeEnvironmentProviders([...features.flatMap((f) => f.providers)]);
}

/**
 * Provides the Tamaro integration for RaiseNow UI.
 *
 * @param cfg A function that returns the configuration for the Tamaro host options.
 */
export function withTamaroIntegration(
  cfg: () => OnlyRequireProps<TamaroHostOptions, 'url'>,
): RaiseNowUiFeature<RaiseNowUiFeatureKind.Tamaro> {
  return makeRaisenowUiFeature(RaiseNowUiFeatureKind.Tamaro, [
    {
      provide: FMNTS_RAISENOW_TAMARO_HOST_OPTIONS,
      useFactory: () => ({
        cleanupSession: true,
        ...cfg(),
      }),
    },
  ]);
}
